// extracted by mini-css-extract-plugin
export default {"DeprecationWarning":"DeprecationWarninguqEmpq3GuFBJ"};